import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted } from 'vue'
import { officeType, departmentType } from '@/types/requests/userRoleSearchForm'
import SelectRoleChecker from '@/router/selectRoleChecker'
import { DEPARTMENT } from "@/services/consts/user_role";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentSelectBox',
  props: {
    modelValue: {},
    organization: {},
    errorMessages: {},
    clearable: { type: Boolean },
    isEdit: { type: Boolean },
    isDepartment: { type: Boolean }
  },
  emits: [
  'update:modelValue'
],
  setup(__props: any, { emit: __emit }) {

const localIsDepartment = ref(false)
const organization_id = ref()

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const isReadonly = computed(() => {
  return props.isEdit
})

onMounted(() => {
  const current_role = SelectRoleChecker.getCurrentRole()
  let organization_type = ""
  if (current_role?.organization_id) {
    organization_id.value = current_role.organization_id
  }
  if (current_role?.organization_type) {
    organization_type = current_role.organization_type
  }
  if (organization_type == DEPARTMENT.type) {
    localIsDepartment.value = true
  }
})

const selectableDepartment = computed(() => {
  if (!props.organization || !props.organization.departments.length) {
    return []
  }
  let departments = [] as departmentType[]

  if (localIsDepartment.value) {
    departments = setSelectableDepartmentsWithDepartmentId()
  } else {
    departments = setSelectableDepartments()
  }
  return departments
})

function setSelectableDepartmentsWithDepartmentId(){
  let departments = [] as departmentType[]

  props.organization.departments.forEach((department) => {
    if (
      organization_id.value == department.id ||
      organization_id.value == department.parent_id
    ) {
      departments.push({
        id: department.id,
        operation_office_id: department.operation_office_id,
        name: department.name,
      })
    }
  })

  if(!props.isEdit && localIsDepartment.value && departments.length == 1){
    modelValue.value = departments[0]
  }
  return departments
}

function setSelectableDepartments(){
  let departments = [] as departmentType[]

  props.organization.departments.forEach((department) => {
    departments.push({
      id: department.id,
      operation_office_id: department.operation_office_id,
      name: department.name,
    })
  })
    if (!props.isEdit && localIsDepartment.value && departments.length == 1) {
      modelValue.value = departments[0]
    }
  return departments
}


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, _mergeProps({
    class: "mb-2",
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    items: selectableDepartment.value,
    "item-title": "name",
    "item-value": "id",
    label: _unref(i18n).global.t('pages.userRoles.search.department')
  }, {'return-object': true}, {
    readonly: isReadonly.value,
    clearable: __props.clearable,
    "error-messages": __props.errorMessages
  }), null, 16, ["modelValue", "items", "label", "readonly", "clearable", "error-messages"]))
}
}

})